import { jsx as _jsx } from "react/jsx-runtime";
const MenuItemSeparator = () => (_jsx("li", { className: "list-none", role: "none", children: _jsx("div", { role: "separator", className: "my-2 h-[1px] bg-[--separator-color]" }) }));
export default MenuItemSeparator;
